import React, { Component } from 'react';
import TextField from './TextField';

class PasswordInput extends Component {
  constructor(props) {
    super(props);
    this.state = { showPassword: false };
    this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
  }

  togglePasswordVisibility() {
    const { showPassword } = this.state;
    this.setState({ showPassword: !showPassword });
  }

  render() {
    const { showPassword } = this.state;
    const inputProps = { ...this.props };

    delete inputProps.label;

    return (
      <TextField
        {...this.props}
        base
        disabled
        showPassword={showPassword}
      />
    );
  }
}

export default PasswordInput;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Warehouses/BaseInput.jsx